import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import loginEn from '../assets/locales/en/login.json'
import commonEn from '../assets/locales/en/common.json'
import notFoundEn from '../assets/locales/en/not-found.json'
import dashboardEn from '../assets/locales/en/dashboard.json'
import twoFactorAuthEn from '../assets/locales/en/two-factor-auth.json'
import forgotPasswordEn from '../assets/locales/en/forgot-password.json'
import cryptoManagementEn from '../assets/locales/en/crypto-management.json'
import pocketsManagementEn from '../assets/locales/en/pockets-management.json'
import reportsManagementEn from '../assets/locales/en/reports-management.json'
import accountManagementEn from '../assets/locales/en/account-management.json'
import customersManagementEn from '../assets/locales/en/customers-management.json'
import systemUsersManagementEn from '../assets/locales/en/system-users-management.json'
import uploadDocumentProcessEn from '../assets/locales/en/upload-document-process.json'
import bankAccountsManagementEn from '../assets/locales/en/bank-accounts-management.json'
import banksBalancesManagementEn from '../assets/locales/en/banks-balances-management.json'
import documentsReadyManagementEn from '../assets/locales/en/documents-ready-management.json'
import customerDetailsManagementEn from '../assets/locales/en/customer-details-management.json'
import documentDetailsManagementEn from '../assets/locales/en/document-details-management.json'
import paymentsToReviewManagementEn from '../assets/locales/en/payments-to-review-management.json'
import customerCompaniesManagementEn from '../assets/locales/en/customer-companies-management.json'
import documentsToReviewManagementEn from '../assets/locales/en/documents-to-review-management.json'
import documentsCompletedManagementEn from '../assets/locales/en/documents-completed-management.json'
import insightsFundingHistoryManagementEn from '../assets/locales/en/insights-funding-history-management.json'
import customerCompanyDetailsManagementEn from '../assets/locales/en/customer-company-details-management.json'
import documentPaymentsDetailsManagementEn from '../assets/locales/en/document-payments-details-management.json'
import documentFindingsDetailsManagementEn from '../assets/locales/en/document-findings-details-management.json'
import individualMoneyTransfersManagementEn from '../assets/locales/en/individual-money-transfers-management.json'

import loginEs from '../assets/locales/es/login.json'
import commonEs from '../assets/locales/es/common.json'
import notFoundEs from '../assets/locales/es/not-found.json'
import dashboardEs from '../assets/locales/es/dashboard.json'
import twoFactorAuthEs from '../assets/locales/es/two-factor-auth.json'
import forgotPasswordEs from '../assets/locales/es/forgot-password.json'
import cryptoManagementEs from '../assets/locales/es/crypto-management.json'
import pocketsManagementEs from '../assets/locales/es/pockets-management.json'
import reportsManagementEs from '../assets/locales/es/reports-management.json'
import accountManagementEs from '../assets/locales/es/account-management.json'
import customersManagementEs from '../assets/locales/es/customers-management.json'
import systemUsersManagementEs from '../assets/locales/es/system-users-management.json'
import uploadDocumentProcessEs from '../assets/locales/es/upload-document-process.json'
import bankAccountsManagementEs from '../assets/locales/es/bank-accounts-management.json'
import banksBalancesManagementEs from '../assets/locales/es/banks-balances-management.json'
import documentsReadyManagementEs from '../assets/locales/es/documents-ready-management.json'
import customerDetailsManagementEs from '../assets/locales/es/customer-details-management.json'
import documentDetailsManagementEs from '../assets/locales/es/document-details-management.json'
import paymentsToReviewManagementEs from '../assets/locales/es/payments-to-review-management.json'
import customerCompaniesManagementEs from '../assets/locales/es/customer-companies-management.json'
import documentsToReviewManagementEs from '../assets/locales/es/documents-to-review-management.json'
import documentsCompletedManagementEs from '../assets/locales/es/documents-completed-management.json'
import customerCompanyDetailsManagementEs from '../assets/locales/es/customer-company-details-management.json'
import documentPaymentsDetailsManagementEs from '../assets/locales/es/document-payments-details-management.json'
import documentFindingsDetailsManagementEs from '../assets/locales/es/document-findings-details-management.json'
import individualMoneyTransfersManagementEs from '../assets/locales/es/individual-money-transfers-management.json'
import insightsFundingHistoryManagementEs from '../assets/locales/es/insights-funding-history-management.json'
const resources = {
  en: {
    login: loginEn,
    common: commonEn,
    dashboard: dashboardEn,
    'not-found': notFoundEn,
    'two-factor-auth': twoFactorAuthEn,
    'forgot-password': forgotPasswordEn,
    'crypto-management': cryptoManagementEn,
    'account-management': accountManagementEn,
    'pockets-management': pocketsManagementEn,
    'reports-management': reportsManagementEn,
    'customers-management': customersManagementEn,
    'system-users-management': systemUsersManagementEn,
    'upload-document-process': uploadDocumentProcessEn,
    'bank-accounts-management': bankAccountsManagementEn,
    'banks-balances-management': banksBalancesManagementEn,
    'documents-ready-management': documentsReadyManagementEn,
    'customer-details-management': customerDetailsManagementEn,
    'document-details-management': documentDetailsManagementEn,
    'payments-to-review-management': paymentsToReviewManagementEn,
    'customer-companies-management': customerCompaniesManagementEn,
    'documents-to-review-management': documentsToReviewManagementEn,
    'documents-completed-management': documentsCompletedManagementEn,
    'customer-company-details-management': customerCompanyDetailsManagementEn,
    'document-payments-details-management': documentPaymentsDetailsManagementEn,
    'document-findings-details-management': documentFindingsDetailsManagementEn,
    'individual-money-transfers-management': individualMoneyTransfersManagementEn,
    'insights-funding-history-management': insightsFundingHistoryManagementEn
  },
  es: {
    login: loginEs,
    common: commonEs,
    dashboard: dashboardEs,
    'not-found': notFoundEs,
    'two-factor-auth': twoFactorAuthEs,
    'forgot-password': forgotPasswordEs,
    'crypto-management': cryptoManagementEs,
    'account-management': accountManagementEs,
    'pockets-management': pocketsManagementEs,
    'reports-management': reportsManagementEs,
    'customers-management': customersManagementEs,
    'system-users-management': systemUsersManagementEs,
    'upload-document-process': uploadDocumentProcessEs,
    'bank-accounts-management': bankAccountsManagementEs,
    'banks-balances-management': banksBalancesManagementEs,
    'documents-ready-management': documentsReadyManagementEs,
    'customer-details-management': customerDetailsManagementEs,
    'document-details-management': documentDetailsManagementEs,
    'payments-to-review-management': paymentsToReviewManagementEs,
    'customer-companies-management': customerCompaniesManagementEs,
    'documents-to-review-management': documentsToReviewManagementEs,
    'documents-completed-management': documentsCompletedManagementEs,
    'customer-company-details-management': customerCompanyDetailsManagementEs,
    'document-payments-details-management': documentPaymentsDetailsManagementEs,
    'document-findings-details-management': documentFindingsDetailsManagementEs,
    'individual-money-transfers-management': individualMoneyTransfersManagementEs,
    'insights-funding-history-management': insightsFundingHistoryManagementEs
  }
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: true,
    ns: [
      'login',
      'common',
      'dashboard',
      'not-found',
      'forgot-password',
      'crypto-management',
      'account-management',
      'customers-management',
      'system-users-management',
      'upload-document-process',
      'bank-accounts-management',
      'documents-ready-management',
      'customer-details-management',
      'document-details-management',
      'payments-to-review-management',
      'documents-to-review-management',
      'documents-completed-management',
      'document-payments-details-management',
      'document-findings-details-management'
    ],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
